import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import DashLayout from '../../components/DashLayout';

const navItems = [
  { to: '/super-admin', icon: '📊', label: 'Dashboard' },
  { to: '/super-admin/businesses', icon: '🏢', label: 'Businesses' },
  { to: '/super-admin/payments', icon: '💰', label: 'Payments' },
  { to: '/super-admin/invoice-report', icon: '🧾', label: 'Invoice Report' },
  { to: '/super-admin/tickets', icon: '🎫', label: 'Support Tickets' },

  { to: '/super-admin/plans', icon: '📦', label: 'Plans' },
  { to: '/super-admin/agents', icon: '👥', label: 'Agent Requests' }
];

const StatCard = ({ label, value, color = '#00d55b', sub }) => (
  <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 20 }}>
    <div style={{ fontSize: 11, color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>{label}</div>
    <div style={{ fontSize: 32, fontWeight: 700, color, lineHeight: 1 }}>{value}</div>
    {sub && <div style={{ fontSize: 12, color: '#555', marginTop: 6 }}>{sub}</div>}
  </div>
);

export default function SuperAdminDashboard() {
  const [stats, setStats] = useState({});
  const [pending, setPending] = useState([]);
  const [recentBiz, setRecentBiz] = useState([]);

  useEffect(() => {
    axios.get('/api/super-admin/stats').then(r => setStats(r.data.data || {})).catch(() => {});
    axios.get('/api/payment/pending').then(r => setPending(r.data.data || [])).catch(() => {});
    axios.get('/api/super-admin/businesses?limit=5').then(r => setRecentBiz(r.data.data || [])).catch(() => {});
  }, []);

  const approve = async (txnId) => {
    try {
      await axios.put(`/api/payment/approve/${txnId}`);
      toast.success('Payment approved & account activated!');
      setPending(p => p.filter(x => x.id !== txnId));
    } catch { toast.error('Approval failed'); }
  };

  const reject = async (txnId) => {
    const reason = window.prompt('Rejection reason:');
    if (!reason) return;
    try {
      await axios.put(`/api/payment/reject/${txnId}`, { reason });
      toast.success('Payment rejected');
      setPending(p => p.filter(x => x.id !== txnId));
    } catch { toast.error('Rejection failed'); }
  };

  return (
    <DashLayout navItems={navItems} role="Super Admin">
      <div style={{ padding: 28 }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>MSChat Admin Panel</h1>
          <p style={{ color: '#555', fontSize: 13, marginTop: 4 }}>MS Discoveries · halo@msdiscoveries.com · +91 9443724724</p>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 28 }}>
          <StatCard label="Total Businesses" value={stats.total_businesses ?? '—'} />
          <StatCard label="Active" value={stats.active_businesses ?? '—'} color="#00d55b" />
          <StatCard label="Pending Approval" value={pending.length} color={pending.length > 0 ? '#f59e0b' : '#555'} sub="Need action" />
          <StatCard label="Suspended" value={stats.suspended_businesses ?? '—'} color="#ff4444" />
          <StatCard label="Pack One" value={stats.pack_one ?? '—'} color="#fff" />
          <StatCard label="Pack Two" value={stats.pack_two ?? '—'} color="#fff" />
          <StatCard label="Pack Three" value={stats.pack_three ?? '—'} color="#fff" />
          <StatCard label="Pack Advanced" value={stats.pack_advanced ?? '—'} color="#fff" />
        </div>

        {/* Pending Payments */}
        {pending.length > 0 && (
          <div style={{ background: '#111', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 12, overflow: 'hidden', marginBottom: 24 }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 14, fontWeight: 600, color: '#f59e0b' }}>⏳ Pending Payment Verifications ({pending.length})</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #1e1e1e' }}>
                  {['Business', 'Plan', 'Amount', 'TXN ID', 'Bank', 'Submitted', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, color: '#555', fontWeight: 500, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pending.map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid #0d0d0d' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{p.company_name}</div>
                      <div style={{ fontSize: 11, color: '#555' }}>{p.email}</div>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 13, color: '#00d55b' }}>{p.plan_name}</td>
                    <td style={{ padding: '12px 16px', fontSize: 13, fontWeight: 600 }}>{p.currency.toUpperCase()} {p.amount}</td>
                    <td style={{ padding: '12px 16px', fontSize: 12, fontFamily: 'monospace', color: '#f59e0b' }}>{p.txn_id}</td>
                    <td style={{ padding: '12px 16px', fontSize: 12, color: '#888' }}>{p.bank_account === 'india' ? '🇮🇳 India' : '🇺🇸 US'}</td>
                    <td style={{ padding: '12px 16px', fontSize: 11, color: '#555' }}>{new Date(p.submitted_at).toLocaleString()}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: 8 }}>
                        {p.screenshot_url && <a href={`https://api.mschat.msdiscoveries.com${p.screenshot_url}`} target="_blank" rel="noreferrer" style={{ padding: '5px 10px', background: '#1a1a1a', border: '1px solid #1e1e1e', color: '#888', borderRadius: 6, fontSize: 12 }}>View</a>}
                        <button onClick={() => approve(p.id)} style={{ padding: '5px 12px', background: 'rgba(0,213,91,0.1)', border: '1px solid #00d55b', color: '#00d55b', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>✓ Approve</button>
                        <button onClick={() => reject(p.id)} style={{ padding: '5px 12px', background: '#1a0000', border: '1px solid #ff4444', color: '#ff4444', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>✕ Reject</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Recent businesses */}
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #1e1e1e', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>Recent Businesses</span>
            <a href="/super-admin/businesses" style={{ fontSize: 12, color: '#00d55b' }}>View all →</a>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #1e1e1e' }}>
                {['Company', 'Plan', 'Status', 'Registered', 'Expires'].map(h => (
                  <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, color: '#555', fontWeight: 500, textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {recentBiz.length === 0 ? (
                <tr><td colSpan={5} style={{ padding: 32, textAlign: 'center', color: '#333', fontSize: 13 }}>No businesses yet</td></tr>
              ) : recentBiz.map(b => (
                <tr key={b.id} style={{ borderBottom: '1px solid #0d0d0d' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>{b.company_name}</div>
                    <div style={{ fontSize: 11, color: '#555' }}>{b.email}</div>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: '#00d55b' }}>{b.plan_key?.replace(/_/g, ' ')}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ fontSize: 11, padding: '2px 10px', borderRadius: 20, background: b.account_status === 'active' ? 'rgba(0,213,91,0.1)' : b.account_status === 'suspended' ? '#1a0000' : '#1a1000', color: b.account_status === 'active' ? '#00d55b' : b.account_status === 'suspended' ? '#ff4444' : '#f59e0b' }}>
                      {b.account_status}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: '#555' }}>{new Date(b.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: b.plan_expires_at && new Date(b.plan_expires_at) < new Date(Date.now() + 7 * 86400000) ? '#ff4444' : '#555' }}>
                    {b.plan_expires_at ? new Date(b.plan_expires_at).toLocaleDateString() : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashLayout>
  );
}